<template>
  <div class="columns">
    <div class="column is-2">
      <b-field label="Schlüssel">
        <b-input v-model.trim="key" custom-class="is-uppercase" :maxlength="caesar ? '1' : ''" />
      </b-field>
      <b-message v-if="text !== '' && key === ''" type="is-warning">
        Bitte Schlüssel eingeben.
      </b-message>
      <b-message v-if="invalidKey" type="is-danger">
        Ungültiger Schlüssel. Nur Großbuchstaben sind erlaubt.
      </b-message>
    </div>
    <div class="column is-5">
      <b-field :label="mode === 'decrypt' ? 'Schlüsseltext' : 'Klartext'">
        <b-input v-model.trim="text" type="textarea" custom-class="is-uppercase" />
      </b-field>
    </div>
    <div class="column is-5" style="word-break:break-all">
      <b-field :label="mode === 'decrypt' ? 'Klartext': 'Schlüsseltext'">
        {{ cipherresult }}
      </b-field>
    </div>
  </div>
</template>

<script>
import vigenere from '@/components/vigenerecipher.js'

export default {
  props: ['mode', 'caesar'],
  data () {
    return {
      key: '',
      text: ''
    }
  },
  computed: {
    cipherresult() {
      if (this.key === '' || this.invalidKey) {
        return ''
      }
      return this.mode == 'decrypt' ? vigenere.decryptVigenere(this.key, this.text) : vigenere.encryptVigenere(this.key, this.text);
    },
    invalidKey() {
      return this.key !== '' && !vigenere.validateKey(this.key)
    }
  }
}
</script>
